import React, { useState } from 'react';
import { Create, CreateBase, CreateProps, DateInput, required, ShowBase, Show, SimpleForm, TextInput, useTranslate, TextField, DateField, SimpleShowLayout, TopToolbar, EditButton, useCreate, useRecordContext, useCreateSuggestionContext, useRedirect } from 'react-admin';
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    RadioGroup,
    FormControlLabel,
    Radio,
    Typography
  } from '@mui/material';

import { Client } from '../../types';


const ClientCreateFuneralButton = () => {
    const [showPanel, setShowPanel] = useState(false);
    const [value, setValue] = React.useState('');
    const [create] = useCreate();
    const record = useRecordContext<Client>();
    const redirect = useRedirect();

    const handleClick = () => {
        if(!showPanel)
          setShowPanel(true);
        else
          setShowPanel(false);
      };
    
      const handleCloseClick = () => {
          setShowPanel(false);
      };
    
      const handleSubmit = (event: any) => {
        if(value == 'deceased'){
            redirect('create', 'funerals', 1, {}, { record: { deceased_client_id: record.id } });
        }
        else{
            redirect('create', 'funerals', 1, {}, { record: { primary_client_id: record.id } });
        }
    };
    return(
        <>
            <Button sx={{lineHeight: '1.5'}} color="primary" size='small' onClick={handleClick}>Create Funeral</Button>
            <Dialog 
                open={showPanel}
                onClose={handleCloseClick}>
                <form onSubmit={handleSubmit}>
                    <DialogContent>
                    <Typography variant="h6" component="div">
                        Create funeral with {record?.name} as
                    </Typography>
                    <br />
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="Deceased"
                        name="radio-buttons-group"
                        onChange={event => setValue(event.target.value)}
                    >
                        <FormControlLabel value="deceased" control={<Radio />} label="Deceased" />
                        <FormControlLabel value="primary_client" control={<Radio />} label="Primary Client" />
                    </RadioGroup>
                    </DialogContent>
                    <DialogActions>
                        <Button type="submit">Save</Button>
                        <Button onClick={handleCloseClick}>Cancel</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
    };  

    export default ClientCreateFuneralButton;